export default "__VITE_ASSET__eb16404b__"